export const sealTypes = [
  { name: "N/A" },
  { name: "Single Seal" },
  { name: "Non-Split Design" },
  { name: "Double Seal" },
  { name: "Split Design" }
];
